import { ModelWithAddressAndContactInfo } from './model-with-address-contact-info';
import { PeriziaUniversale } from './perizia-universale';

export class AllegatoPeriziaUniversale extends ModelWithAddressAndContactInfo {
  static apiUrl: string = "allegati_perizia_universale";

  nome: string;

  perizia_universale: PeriziaUniversale;

  deserialize(input: any): AllegatoPeriziaUniversale {
    let retV: AllegatoPeriziaUniversale = new AllegatoPeriziaUniversale();

    retV = super.deserialize(input) as AllegatoPeriziaUniversale;

    if (input?.perizia_universale) {
      retV.perizia_universale = new PeriziaUniversale().deserialize(input.perizia_universale);
    }


    return retV;
  }

}
